export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = () => {
    const result = reader.result;

    if (typeof result !== 'string') {
      reject(new Error('Could not read file'));
      return;
    }

    const base64 = result.includes(',') ? result.split(',')[1] : result;
    resolve(base64);
  };

  reader.onerror = () => reject(reader.error || new Error('Could not read file'));
  reader.readAsDataURL(file);
});

export const buildGbFormUploadPayload = async (code, pdf_file, pdf_file_1, pdf_file_2) => {
  const [pdfFile, pdfFile1, pdfFile2] = await Promise.all([
    fileToBase64(pdf_file),
    fileToBase64(pdf_file_1),
    fileToBase64(pdf_file_2),
  ]);

  return {
    upload_format: 'base64',
    pdf_file: pdfFile,
    pdf_file_1: pdfFile1,
    pdf_file_2: pdfFile2,
    pdf_file_name: pdf_file.name || 'document.pdf',
    pdf_file_1_name: pdf_file_1.name || 'document.pdf',
    pdf_file_2_name: pdf_file_2.name || 'document.pdf',
    EORI_NO: '11111111',
    TARIC_CODE: '11111111',
    GOODS_ORIGIN: '11111111',
    GOODS_DESC: '11111111',
    GOODS_VALUE: '11111111',
    GROSS_WEIGHT: '11111111',
    NET_WEIGHT: '11111111',
    BOOKING_CODE: code,
  };
};
